import { RequestService } from '../../../../../common/services/RequestService';
import { APPLIANCES_GET } from '../../constants';

export const getAppliancesRequest = payload => {
  return RequestService.get(APPLIANCES_GET);
};
